// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Fz06","clinicsSelect":"styles_clinicsSelect__2i3o_"};